import React from 'react'
import Manager from '../../public/components/Manager'
import AnnouncementDetail from './AnnouncementDetail'
Ext.require('Ext.Toast')

const config = {
    buttons: [
        { text: '添加...', handler: ({ showDetail, refreshPage }) => showDetail(props => <AnnouncementDetail {...props} id={0} />) },
    ],
    columns: [
        { _text: '编号', field: 'BulletinNumber', minWidth: 250, filter: true, },
        { _text: '主题', field: 'BulletinTitle', minWidth: 150, search: true, flex: 5, },
        { _text: '发布人', field: 'Creator', minWidth: 150 },
        { _date: '发布日期', field: 'CreateTime', minWidth: 150, flex: 5, },
    ],
    onDoubleTap: ({ showDetail }, data) => showDetail(props => <AnnouncementDetail {...props} id={data.id} />),
}

export default props => <Manager {...props} config={config} />